import { Box } from "@mui/material";
import { useListContext } from "react-admin";
import ApproveConfirmModal from "./ApproveConfirmModal";
import DeclineReasonModal from "./DeclineReasonModal";

const BulkApprovalToolbar = ({ stage }) => {
  const { selectedIds, resource } = useListContext();

  return (
    <Box sx={{ display: "flex", gap: 1 }}>
      <ApproveConfirmModal
        stage={stage}
        ids={selectedIds}
        resource={resource}
        triggerLabel="Одобри избраните"
      />
      <DeclineReasonModal
        stage={stage}
        ids={selectedIds}
        resource={resource}
        triggerLabel="Отхвърли избраните"
      />
    </Box>
  );
};

export default BulkApprovalToolbar;
